import { render, staticRenderFns } from "./VirtualDesktopTableBody.vue?vue&type=template&id=00501450&scoped=true"
import script from "./VirtualDesktopTableBody.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopTableBody.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopTableBody.vue?vue&type=style&index=0&id=00501450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00501450",
  null
  
)

export default component.exports